import '@/assets/iconfont/iconfont.css'
import '@/assets/scss/common.scss'
import '@babel/polyfill'
;(window as any).vue = Vue
import store from '@/common/store'
import Vue from 'vue'
import VueRouter from 'vue-router'
import { Store } from 'vuex'
// import './../assets/scss/reset.scss'
// es babel polyfill
// import 'core-js/fn/promise'
// import 'core-js/fn/array'
// import 'core-js/fn/object/assign'
import './../plugins/antDesign'
import { sa } from './../utils/sa'
import { getUrlParams } from './../utils/urlUtils'
import App from './App.vue'
let tackParam: any = {
  platformType: 'Web',
  product: '内容库',
  userType: '老师'
}
let customer = getUrlParams(location.href).user
if (customer) {
  tackParam.customer_id = customer
}

setTimeout(() => {
  sa.registerPage(tackParam)
  sa.quick('autoTrack')
  Vue.prototype.$sa = sa
}, 50)
// tslint:disable-next-line:empty
export function getRootVue(params: any) {
  let {
    router
  }: {
    router: VueRouter
  } = params
  // const router = get
  return new Vue({
    router,
    store,
    render: (h) => h(App)
  }).$mount('#app')
}
